<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-action corner">
      <div class="button button-close">
        <button class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span class="popup-title-main">絞り込みの設定</span>
        </div>
        <div class="popup-content">
          <div class="list01">

            <ul class="list01-list"
              v-for="(classification, index) in data.classifications" :key="'classifications_' + index"
            >
              <li class="list01-item is-parent" :class="{' bottom-bold' : index === data.classifications.length - 1}">
                <div class="label">
                  <div class="formparts checkbox">
                    <input 
                      :id="'classification_' + index"
                      type="checkbox"
                      :value="classification.code"
                      v-model="data.filterClassifications"
                    >
                    <label 
                      :for="'classification_' + index"
                    >{{classification.value1}}<FontawesomeIcon icon="check" class="icn" /></label>
                  </div>
                </div>
              </li>
            </ul>

            <ul class="list01-list"
              v-for="(category, index) in data.categories" :key="'category_' + index"
            >
              <li class="list01-item is-parent">
                <div class="label">
                  <div class="formparts checkbox">
                    <input 
                      :id="'category_' + index"
                      type="checkbox"
                      :value="category.code"
                      v-model="data.filterCategories"
                    >
                    <label 
                      :for="'category_' + index"
                    >{{category.value1}}<FontawesomeIcon icon="check" class="icn" /></label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

export default defineComponent({
  props: {
    parentData: {
      type: Object,
      required: true
    }
  },
  setup (props, context) {

    const data = props.parentData

    const close = () => {
      context.emit('closeInformationExtract')
    }

    return {
      data,
      close
    }
  }
})
</script>

<style lang="scss" scoped>
</style>
